export enum AppRoutes {
  Login = 'login',
  LoginRedirect = 'login/redirect',
  CaseList = 'case-list',

  UploadedMedicalRecords = 'uploaded-medical-records',
  AiProcessedDocuments = 'ai-processed-documents',

  FullBundle = 'full-bundle',
  LightBundle = 'light-bundle',

  Timeline = 'timeline',
  Chronology = 'chronology',

  UserManagement = 'user-management',
  ActiveUsers = 'active-users',
  DeactivatedUsers = 'deactivated-users',

  GlobalAdminDashboard = 'global-admin-dashboard',

  MedicalRecords = 'medical-records-list',
  // MedicalRecords = 'medical-records',

  GdprCheck = 'gdpr',
}
